import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { ToastContainer, toast } from "react-toastify";

const TicketFiles = ({ ticketId, getAuthHeader }) => {
  const [files, setFiles] = useState([]);
  const [fileForm, setFileForm] = useState({
    file_name: "",
    file_description: "",
    file: null,
  });
  const [uploading, setUploading] = useState(false);

  const loadFiles = async () => {
    const res = await axios.get(
      `${API_BASE_URL}/tickets/${ticketId}/files`,
      { headers: getAuthHeader() }
    );
    setFiles(res.data || []);
  };

  useEffect(() => {
    loadFiles();
  }, [ticketId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFileForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const f = e.target.files[0];
    setFileForm((prev) => ({ ...prev, file: f }));
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!fileForm.file) {
       toast.error("Please select a file");
      return;
    }

    try {
      setUploading(true);

      const formData = new FormData();
      formData.append("file_name", fileForm.file_name);
      formData.append("file_description", fileForm.file_description);
      formData.append("attachment_file", fileForm.file);

      await axios.post(
        `${API_BASE_URL}/tickets/${ticketId}/files`,
        formData,
        {
          headers: {
            ...getAuthHeader(),
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert("Attachment uploaded");
      setFileForm({ file_name: "", file_description: "", file: null });
      loadFiles();
    } catch (err) {
  setUploading(false);

  if (err.response && err.response.status === 422) {
    // Show all error messages
    const errors = err.response.data.errors;
    Object.values(errors).forEach((messages) => {
      toast.error(messages[0]); // show each message
    });
  } else {
    toast.error("File upload failed");
  }
}

  };

  return (
    <div>
          <ToastContainer position="bottom-right" />
      {/* ADD ATTACHMENT FORM */}
      <div className="card p-3 mb-3">
        <h5 className="mb-3">Add Attachment</h5>
        <form onSubmit={submit}>
          <div className="mb-3">
            <label className="form-label">Title</label>
            <input
              className="form-control required-input"
              name="file_name"
              value={fileForm.file_name}
              onChange={handleInputChange}
              placeholder="Title"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Attachment File</label>
            <input
              type="file"
              className="form-control required-input"
              onChange={handleFileChange}
            />
            <small>Allowed file types: png, jpg, pdf, doc, xls, etc.</small>
          </div>

          <div className="mb-3">
            <label className="form-label">Description</label>
            <textarea
              className="form-control required-input"
              rows={3}
              name="file_description"
              value={fileForm.file_description}
              onChange={handleInputChange}
              placeholder="Description"
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={uploading}
          >
            {uploading ? "Uploading..." : "Save"}
          </button>
        </form>
      </div>

      {/* ATTACHMENT LIST */}
      <h5 className="mb-2">Attachment List</h5>
      <div className="table-responsive">
        <table className="table table-hover table-striped table-bordered">
          <thead>
            <tr>
              <th>Option</th>
              <th>Title</th>
              <th>Description</th>
              <th>Date & Time</th>
            </tr>
          </thead>
          <tbody>
            {files.length === 0 && (
              <tr>
                <td colSpan={4}>No attachments found</td>
              </tr>
            )}

            {files.map((f) => (
              <tr key={f.id ?? f.ticket_attachment_id}>
                <td>
                  {f.download_url && (
                    <a
                      href={f.download_url}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-sm btn-info"
                    >
                      Download
                    </a>
                  )}
                </td>
                <td>{f.file_title ?? f.file_name}</td>
                <td>{f.file_description}</td>
                <td>{f.created_at}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TicketFiles;
